import {Component, Inject, OnInit} from '@angular/core';
import {DOCUMENT} from '@angular/common';
import {Router} from '@angular/router';


@Component({
    selector: 'app-sitesutiles',
    templateUrl: './sitesutiles.component.html',
    styleUrls: ['./sitesutiles.component.css']
})
export class SitesutilesComponent implements OnInit {
    images = [
        {src: 'assets/images/portailpresidence.svg', url: 'http://www.pm.gov.tn/'},
        {src: 'assets/images/tunepsmanual1.svg', url: 'http://www.tuneps-kit.tn/'},
        {src: 'assets/images/epeople1.png', url: 'http://www.e-people.gov.tn'},
        {src: 'assets/images/ance2.png', url: 'https://www.tuntrust.tn/'},
        {src: 'assets/images/haicop1.svg', url: 'http://www.marchespublics.gov.tn/'}

    ];
    imageObject: Array<object> = [{
        image: 'assets/images/site1.PNG',
        thumbImage: 'assets/images/site1.PNG'

    }, {
        image: 'assets/images/site1.PNG',
        thumbImage: 'assets/images/site1.PNG'

    }, {
        image: 'assets/images/site1.PNG',
        thumbImage: 'assets/images/site1.PNG',

    }, {
        image: 'assets/images/site1.PNG',
        thumbImage: 'assets/images/site1.PNG',

    }, {
        image: 'assets/images/site1.PNG',
        thumbImage: 'assets/images/site1.PNG',

    }];
    slideOptions = {
        nav: true,
        dots: true,
        loop: false,
        margin: 10,
        responsiveClass: true,
        // responsive object contains responsive options.
        responsive: {
            0: {
                items: 1,
                dots: true
            },
            600: {
                items: 3
            },
            1000: {
                items: 5
            }
        }
    };

    constructor(private router: Router,
                @Inject(DOCUMENT) private document: Document) {
    }

    goToUrl(url): void {
        //this.router.navigateByUrl(url);

        //this.document.location.href = url;
        window.open(url);
        // window.location.href='http://www.google.com/';

    }

    ngOnInit(): void {
    }

    imageClickHandler(e) {

    }
}
